<div class="allteams">All Teams Allowances</div>
<app-allowances-highcharts-container></app-allowances-highcharts-container>

